/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Sibling-page nav strip rendered at the bottom of WMS-showcase
 * sub-pages. Hides the current page from the strip (no self-link)
 * so visitors only see "more to explore" — not a redundant link to
 * the page they're already on.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, BookMarked, PlayCircle } from 'lucide-react';

const SIBLINGS_BY_DOMAIN = {
  wms: [
    { path: '/domain/wms/case-studies', label: 'Case Studies',  Icon: Briefcase },
    { path: '/domain/wms/resources',    label: 'Resources',     Icon: BookMarked },
    { path: '/domain/wms/showcase',     label: 'ML Simulation', Icon: PlayCircle },
  ],
};

const ShowcaseSiblingNav = ({ currentPath, domain = 'wms' }) => {
  const all = SIBLINGS_BY_DOMAIN[domain] || [];
  const others = all.filter((s) => s.path !== currentPath);
  if (others.length === 0) return null;

  return (
    <nav
      aria-label="More in WMS showcase"
      className="mt-16 bg-brand-bgOff border border-brand-border rounded-brand p-5 sm:p-6 text-center"
    >
      <p className="text-[11px] font-bold tracking-[2px] uppercase text-brand-cyan mb-4">
        More in WMS
      </p>
      <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
        {others.map(({ path, label, Icon }) => (
          <Link
            key={path}
            to={path}
            className="inline-flex items-center gap-2 bg-white border border-brand-border rounded-brandPill px-4 py-2 text-sm font-medium text-brand-text hover:border-brand-cyan hover:-translate-y-px hover:shadow-brand transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-cyan focus:ring-offset-2 no-underline"
          >
            <Icon className="w-4 h-4 text-brand-cyan" aria-hidden="true" />
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default ShowcaseSiblingNav;
